// App.tsx — top-level shell.
//
// Provider tree from outside-in:
//   <ErrorBoundary>                  — catches uncaught render errors
//     <QueryClientProvider>          — TanStack Query cache for useMe / useProject
//       <RouterProvider router={...}>
//         <RootLayout>               — INSIDE router: ThemeProvider, ToastProvider,
//                                      AppSideEffects (useLanguageSync + apiClient navigate wire)
//           <AuthedLayout>           — ProtectedRoute + Navbar for authed routes
//             <route element>
//
// ThemeProvider must be inside RouterProvider (it reads route params via
// useOptionalProjectParams). ToastProvider lives next to it so toast
// emitters in any descendant work.

import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from './lib/queryClient.js';
import { router } from './router/index.js';
import { ErrorBoundary } from './components/layout/ErrorBoundary.js';

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
